export enum InventoryCheckType {
  /// <summary>
  /// Verify quantities of products at a specific point in time
  /// </summary>
  StockTake,

  /// <summary>
  /// Track quality assurance checks for a manufacturing or production process
  /// </summary>
  QualityManagement,

  /// <summary>
  /// Track the inventory of non-stock items, such as office equipment, furniture, or vehicles
  /// </summary>
  AssetManagement,

  /// <summary>
  /// Any type of audit or compliance-related activity, such as an IT security audit, a financial audit, or a health and safety inspection
  /// </summary>
  AuditTracking,
}

export enum InventoryCheckEventType {
  Scheduled = 'Scheduled',
  InProgress = 'In Progress',
  AwaitingAuthorisation = 'Awaiting Confirmation',
  Authorised = 'Awaiting Authorisation',
  Completed = 'Authorised',
  Rejected = 'Declined',
  Cancelled = 'Cancelled',
}

export const inventoryCheckEventMap = {
  100: InventoryCheckEventType.Scheduled,
  200: InventoryCheckEventType.InProgress,
  300: InventoryCheckEventType.AwaitingAuthorisation,
  350: InventoryCheckEventType.Authorised,
  400: InventoryCheckEventType.Rejected,
  500: InventoryCheckEventType.Completed,
  600: InventoryCheckEventType.Cancelled,
};
